<template>
  <div class="root_page">
    <div class="table_wrapper">
      <div class="ctrl-wrapper">
        <div class="search_wrapper">
          <div class="common_search_wrapper">
            <Input
              class="search-ipt"
              type="text"
              v-model="searchIpt.name"
              placeholder="请输入平台昵称"
              clearable
            />
            <Input
              class="search-ipt"
              type="text"
              v-model="searchIpt.wxName"
              placeholder="请输入微信昵称"
              clearable
            />
            <Input
              class="search-ipt"
              type="text"
              v-model="searchIpt.phone"
              placeholder="请输入手机号"
              clearable
            />
            <Button
              type="primary"
              icon="md-search"
              class="search_tn"
              data-level="common"
              @click="getUserList"
            >搜索</Button>
            <Button
              class="top_search_btn"
              type="primary"
              ghost
              icon="ios-funnel"
              @click="topSearchStatus = true"
            >高级搜索</Button>
          </div>
        </div>
      </div>
      <Table class="main_table" size="large" stripe border :columns="tableHeader" :data="tableData">
        <template slot-scope="{ row, index}" slot="wxGzhId">
          <Icon v-if="row.wxGzhId > 0" type="md-checkmark"></Icon>
          <Icon v-else type="md-remove"></Icon>
        </template>
        <template slot-scope="{ row, index}" slot="rosterId">
          <Icon v-if="row.rosterId > 0" type="md-checkmark"></Icon>
          <Icon v-else type="md-remove"></Icon>
        </template>
        <template slot-scope="{ row, index}" slot="parentId">
          <Icon v-if="row.parentId > 0" type="md-checkmark"></Icon>
          <Icon v-else type="md-remove"></Icon>
        </template>
        <template slot-scope="{ row, index}" slot="action">
          <div class="jump_color" @click="checkDetail(row.id)">详情</div>
          <div class="jump_color" @click="deleteWaiterUsers(row.phone)">清除</div>
        </template>
      </Table>
    </div>
    <paging :totalNum="totalNum" :pageSize="pageSize" @pageCallback="getUserList"></paging>
    <Modal class="top_search_modal" v-model="topSearchStatus" title="高级搜索">
      <div class="top_search_wrapper">
        <Input
          class="search-ipt search_item"
          type="text"
          v-model="searchIpt.seniorName"
          placeholder="请输入用户名称"
          clearable
        />
        <Input
          class="search-ipt search_item"
          type="text"
          v-model="searchIpt.seniorWxName"
          placeholder="请输入微信昵称"
          clearable
        />
        <Input
          class="search-ipt search_item"
          type="text"
          v-model="searchIpt.seniorId"
          placeholder="请输入用户编号"
          clearable
        />
        <Input
          class="search-ipt search_item"
          type="text"
          v-model="searchIpt.seniorPhone"
          placeholder="请输入手机号"
          clearable
        />
        <Input
          class="search-ipt search_item"
          type="text"
          v-model="searchIpt.seniorSId"
          placeholder="请输入学校编号"
          clearable
        />
        <Input
          class="search-ipt search_item"
          type="text"
          v-model="searchIpt.seniorCId"
          placeholder="请输入班级编号"
          clearable
        />
        <div class="search_time search_item">
          <DatePicker
            class="time"
            :value="searchIpt.seniorBeginDate"
            type="date"
            @on-change="getBeginDate"
            format="yyyy-MM-dd"
            placeholder="请输入开始时间"
          ></DatePicker>
          <DatePicker
            class="time"
            :value="searchIpt.seniorEndDate"
            type="date"
            @on-change="getEndDate"
            format="yyyy-MM-dd"
            placeholder="请输入结束时间"
          ></DatePicker>
        </div>
        <Select class="search_item" v-model="searchIpt.seniorType" clearable>
          <Option v-for="item in userType" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </div>
      <div class="ctrl-footer" slot="footer">
        <Button class="closed_btn" @click="topSearchStatus = false">取消</Button>
        <Button class="add_record_btn" type="info" icon="md-search" @click="topSearchFn">搜索</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { dealDate } from "../common/common";
import { _getUserList,_deleteWaiterUsers } from "../api/api";
import paging from "../templates/Paging.vue";
export default {
  name:"User",
  components: { paging },
  data() {
    return {
      pageSize: 10, // 每页条数
      totalNum: 0, // 数据总条数
      searchLevel: "common", // common普通搜索，senior高级搜索
      topSearchStatus: false, // 高级搜索显示状态
      searchIpt: {
        name: "",
        wxName: "",
        phone: "",
        seniorName: "",
        seniorWxName: "",
        seniorPhone: "",
        seniorBeginDate: "",
        seniorEndDate: "",
        seniorId: "",
        seniorSId: "",
        seniorCId: "",
        seniorType: 0
      },
      tableHeader: [
        {
          title: "ID",
          key: "id",
          width: 86
        },
        {
          title: "微信昵称",
          key: "nickname"
        },
        {
          title: "平台昵称",
          key: "name"
        },
        {
          title: "手机号",
          key: "phone",
          width: 125
        },
        {
          title: "认证日期",
          key: "createTime",
          width: 150,
          sortable: true
        },
        {
          title: "公众号",
          key: "wxGzhId",
          slot: "wxGzhId"
        },
        {
          title: "教师身份",
          key: "rosterId",
          slot: "rosterId"
        },
        {
          title: "家长身份",
          key: "parentId",
          slot: "parentId"
        },
        {
          title: "操作",
          slot: "action"
        }
      ],
      tableData: [],
      userType: [
        {
          value: 0,
          label: "全部"
        },
        {
          value: 1,
          label: "老师"
        },
        {
          value: 2,
          label: "家长"
        }
      ]
    };
  },
  methods: {
//    清除用户
    deleteWaiterUsers(phone){
      const self = this;
      _deleteWaiterUsers(phone).then(res => {
        console.log("res",res);
        if(res.code === 0) {
          self.getUserList();
        }
      })
    },
    //      获取用户列表
    getUserList(msg) {
      const self = this;
      let params = {
        name:
          self.searchLevel === "common"
            ? self.searchIpt.name
            : self.searchIpt.seniorName,
        wxName:
          self.searchLevel === "common"
            ? self.searchIpt.wxName
            : self.searchIpt.seniorWxName,
        phone:
          self.searchLevel === "common"
            ? self.searchIpt.phone
            : self.searchIpt.seniorPhone,
        beginDate: self.searchIpt.seniorBeginDate
          .toString()
          .split("-")
          .join(""),
        endDate: self.searchIpt.seniorEndDate
          .toString()
          .split("-")
          .join(""),
        id: self.searchIpt.seniorId,
        sId: self.searchIpt.seniorSId,
        cId: self.searchIpt.seniorCId,
        type: self.searchIpt.seniorType,
        page: typeof msg === "object" && msg.pageNum ? msg.pageNum - 1 : 0,
        size: self.pageSize
      };
      _getUserList({ params: params }).then(res => {
        if (res.code === 0) {
          self.tableData = res.data.content;
          self.totalNum = res.data.total;
          self.tableData.length &&
            self.tableData.forEach(item => {
              item.createTime = dealDate(item.createTime);
            });
        }
      });
    },
    checkDetail(id) {
      this.$router.push(`/user/detail?id=${id}`);
    },
    //      获取高级搜索的开始时间
    getBeginDate(res) {
      this.searchIpt.seniorBeginDate = res;
    },
    //      获取高级搜索的结束时间
    getEndDate(res) {
      this.searchIpt.seniorEndDate = res;
    },
    //      高级搜索确认
    topSearchFn() {
      this.searchLevel = "senior";
      this.getUserList();
      this.searchIpt = {
        seniorName: "",
        seniorWxName: "",
        seniorPhone: "",
        seniorBeginDate: "",
        seniorEndDate: "",
        seniorId: "",
        seniorType: 0
      };
      this.topSearchStatus = false;
    },
    //      关闭高级搜索
    cancelSearchModel() {}
  },
  created() {
    if (this.$route.query.name) {
      this.searchIpt.name = this.$route.query.name;
    }
    if (this.$route.query.sId) {
      this.searchIpt.seniorSId = this.$route.query.sId;
    }
    if (this.$route.query.cId) {
      this.searchIpt.seniorCId = this.$route.query.cId;
    }
  },
  mounted() {
    this.getUserList();
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/User.vue